// extracted by mini-css-extract-plugin
export default {"subform-block":"ForgotPasswordForm_subform-block__PohPX"};